export type DevClinicalDataState = "unavailable" | "stale" | null;
export type DevClinicalDataScope =
  "calendar" | "calendar-schedule" | "documents" | "labs" | "cryo";

function isDevClinicalDataFixtureEnabled(): boolean {
  if (__DEV__ || process.env.EXPO_PUBLIC_DEV_TOOLS === "true") return true;
  if (typeof window === "undefined") return false;
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get("test") === "1" && params.has("dev_clinical_data_scope");
  } catch {
    return false;
  }
}

function getRequestedState(scope: DevClinicalDataScope): string | null {
  if (!isDevClinicalDataFixtureEnabled() || typeof window === "undefined") {
    return null;
  }
  try {
    const params = new URLSearchParams(window.location.search);
    const requestedScope = params.get("dev_clinical_data_scope");
    if (requestedScope && requestedScope !== scope) return null;
    return params.get("dev_clinical_data_state");
  } catch {
    return null;
  }
}

/** Deterministic real-route fixture used for review screenshots and QA. */
export function getDevClinicalDataState(
  scope: DevClinicalDataScope,
): DevClinicalDataState {
  const state = getRequestedState(scope);
  return state === "unavailable" || state === "stale" ? state : null;
}

export function isDevClinicalDataLoading(scope: DevClinicalDataScope): boolean {
  return getRequestedState(scope) === "loading";
}
